import React from 'react';
import { HeroSection } from './components/HeroSection';
import { StorySection } from './components/StorySection';
import { FailedAttemptsSection } from './components/FailedAttemptsSection';
import { MechanismSection } from './components/MechanismSection';
import { DeliverablesSection } from './components/DeliverablesSection';
import { AudienceSection } from './components/AudienceSection';
import { StepsSection } from './components/StepsSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-gray-800 selection:bg-emerald/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <StorySection data-id="element-2" />
      <FailedAttemptsSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <DeliverablesSection data-id="element-5" />
      <AudienceSection data-id="element-6" />
      <StepsSection data-id="element-7" />
      <ProofSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <FinalOfferSection data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}